import { makeStyles } from '@material-ui/core';
import { useAllowDrillIn } from '../../stores/SessionStore';
import Link from './Link';

const useDrillInLinkStyles = makeStyles({
    nonLinkText: {
        fontWeight: 500,
    },
});

export function DrillInLink({ children, ...rest }) {
    const styles = useDrillInLinkStyles();
    const [canDrillIn] = useAllowDrillIn();

    return canDrillIn ? <Link {...rest}>{children}</Link> : <span className={styles.nonLinkText}>{children}</span>;
}
